module.exports = "/images/pin-photography.png?d1932014c3d849954361185265e13f76";